import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { paths } from '@fleet/environment';
import { handleApiError } from '@fleet/utilities';
import { ApiResponse, OrganisationClassificationModel } from '@fleet/model';

/**
 * The organisation classification (rulings 5 and 6): the segments and their categories, with the words a screen shows
 * and, on a category, the kind of recurring route plan its organisations run. Reference data — read only, seeded by
 * Liquibase — so the Hub reads it once per form rather than caching it anywhere clever.
 */
@Injectable({
  providedIn: 'root',
})
export class OrganisationClassificationApiService {
  host: string;

  constructor(private http: HttpClient, @Inject('env') env: any) {
    this.host = env.host + paths.organisation;
  }

  /** The active segments and categories; `all` also returns the ones no longer offered, for rendering an old value. */
  get(all?: boolean): Observable<ApiResponse<OrganisationClassificationModel> | any> {
    const params = all ? new HttpParams().set('all', 'true') : new HttpParams();
    return this.http.get(`${this.host}/classification`, { params }).pipe(timeout(30_000), catchError(handleApiError));
  }
}
